import { render, staticRenderFns } from "./report-tangniaobing.vue?vue&type=template&id=544f51f0&scoped=true&"
import script from "./report-tangniaobing.vue?vue&type=script&lang=ts&"
export * from "./report-tangniaobing.vue?vue&type=script&lang=ts&"
import style0 from "./report-tangniaobing.vue?vue&type=style&index=0&id=544f51f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f51f0",
  null
  
)

export default component.exports